package com.example.mystybag.core.model

import androidx.compose.material3.SnackbarDuration

data class SnackbarConfig(
    val message : String,
    val action  : String? = null,
    val duration: SnackbarDuration = SnackbarDuration.Short,
)
